import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

const StyledInput = styled.input`
  display: inline-block;
  width:100%;
  font-size: ${({ theme, inputSize }) =>
    _.get(
      theme,
      ['input', 'fontSize', inputSize],
      _.get(theme, 'input.fontSize.normal')
    )};
  line-height: 1.5;
  box-sizing: border-box;
  background-clip: padding-box;
  color: ${({ theme }) => _.get(theme, 'input.color')};
  background: ${({ theme }) =>
    _.get(theme, 'input.background', _.get(theme, 'colors.background'))};
  padding: ${({ theme, inputSize }) =>
    _.get(
      theme,
      ['input', 'padding', inputSize],
      _.get(theme, 'input.padding.normal')
    )};
  border-radius: ${({ theme }) =>
    _.get(
      theme,
      'input.borderRadius',
      _.get(theme, 'border.default.radius', 0)
    )};
  ${({ theme, inputSize }) =>
    _.get(theme, ['input', 'height', inputSize], false)
      ? 'min-height: ' + _.get(theme, ['input', 'height', inputSize]) + ';'
      : ''}
  border: ${({ theme }) =>
    _.get(
      theme,
      'input.border',
      _.get(theme, 'border.default.width') +
        ' ' +
        _.get(theme, 'border.default.style')
    )};
  border-color: ${({ theme }) =>
    _.get(theme, 'input.borderColor', _.get(theme, 'border.default.color'))};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &:invalid {
    outline: none;
    box-shadow: none;
  }
  transition: ${({ theme }) => _.get(theme, 'input.transition')};
  &:hover {
    ${({ theme }) => _.get(theme, 'input.state.hover', null)}
  }
  &:active {
    ${({ theme }) => _.get(theme, 'input.state.active', null)}
  }
  &:focus {
    ${({ theme }) => _.get(theme, 'input.state.focus', null)}
  }
`;

const Input = React.forwardRef(({ className = '', inputSize = 'normal', theme, type = 'text', ...rest }, ref) => {
  return (
    <StyledInput type={type} inputSize={inputSize} className={className} theme={theme} ref={ref} {...rest} />
  );
});

export default React.memo(Input);
